import React from "react";

const chatMdComponents = {
  h1: ({ children }) => <p className="font-bold text-sm mb-1 mt-2">{children}</p>,
  h2: ({ children }) => <p className="font-bold text-sm mb-1 mt-2">{children}</p>,
  h3: ({ children }) => <p className="font-semibold text-sm mb-0.5 mt-1.5">{children}</p>,
  h4: ({ children }) => <p className="font-semibold text-xs uppercase tracking-wide mb-0.5 mt-1 opacity-70">{children}</p>,
  p: ({ children }) => <p className="mb-1.5 last:mb-0 leading-relaxed">{children}</p>,
  ul: ({ children }) => <ul className="mb-2 space-y-0.5 pl-0">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-4 mb-2 space-y-0.5">{children}</ol>,
  li: ({ children, ordered }) => (
    <li className="flex items-start gap-1.5">
      {!ordered && <span className="mt-[7px] h-1 w-1 rounded-full bg-current opacity-50 shrink-0" />}
      <span className="leading-relaxed">{children}</span>
    </li>
  ),
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  em: ({ children }) => <em className="italic opacity-80">{children}</em>,
  code: ({ children }) => (
    <code className="bg-black/10 px-1 py-0.5 rounded text-xs font-mono">{children}</code>
  ),
  hr: () => <hr className="border-current opacity-15 my-2" />,
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-current opacity-60 pl-3 my-1.5 italic">{children}</blockquote>
  ),
};

export default chatMdComponents;
